import { getTokensFromPairSymbol } from "../trade";

/**
 * @description This function checks if the order book should be enabled for a given pair symbol based on the campaign token.
 * @param pairSymbol - The pair symbol to check.
 * @param campaignToken - The campaign token to check.
 * @returns True if the order book should be enabled, false otherwise.
 */
export const shouldOrderBookBeEnabled = (pairSymbol: string, campaignToken: string) => {
  const tokens = getTokensFromPairSymbol(pairSymbol);
  return tokens.includes(campaignToken);
};
